<template>
  <div class="service-wrap" v-if="course.service && course.service.length > 0">
    <span class="label">课程服务：</span>
    <div ref="services" class="services clearfix">
      <span v-for="(s, index) in course.service" :key="index" class="service">
        <i class="el-icon-circle-check"></i>
        <span>{{ s.name }}</span>
      </span>
    </div>
    <div class="more-wrap" @click="showDialog = true">
      <span class="color-9">详情</span>
      <img class="more-img" src="@/assets/images/course/service-more@2x.png" />
    </div>
    <el-dialog class="service-dialog" :visible.sync="showDialog" title="课程服务" width="800px">
      <div v-for="(s, index) in course.service" :key="index" class="dialog-service">
        <div class="flex-row">
          <img class="dialog-service_icon" src="@/assets/images/course/service-icon@2x.png" />
          <span class="dialog-service_name bold5">{{ s.name }}</span>
        </div>
        <div class="dialog-service_description">{{ s.description }}</div>
      </div>
      <template v-slot:footer>
        <el-button type="primary" @click="showDialog = false">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'CourseShowService',
  props: {
    course: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      hasServiceMore: false,
      showDialog: false,
    };
  },
  watch: {
    course: function () {
      this.$nextTick(() => {
        this.setServiceMore();
      });
    },
  },
  created() {
    this.$nextTick(() => {
      this.setServiceMore();
    });
  },
  methods: {
    setServiceMore() {
      if (!this.$refs.services) {
        return;
      }
      let firstY = 0;
      this.$refs.services.querySelectorAll('.service').forEach((ele, index) => {
        let rect = ele.getBoundingClientRect();
        if (index == 0) {
          firstY = rect.y;
        } else if (firstY != rect.y) {
          ele.parentNode.removeChild(ele);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.service-wrap {
  font-size: 14px;
  display: flex;
  position: relative;

  .label {
    color: #999;
    flex-shrink: 0;
    margin-right: 8px;
  }

  .services {
    height: 20px;
    overflow: hidden;
    margin-bottom: 15px;
  }

  .service {
    margin: 0 0 0 12px;
    float: left;

    &:first-child {
      margin-left: 0;
    }

    .el-icon-circle-check {
      margin-right: 5px;
      color: #ff2d28;
    }
  }

  .more-wrap {
    display: flex;
    align-items: center;
    height: 20px;
    white-space: nowrap;
    cursor: pointer;
    margin: 0 20px 0 13px;
  }

  .more-img {
    width: 7px;
    height: 12px;
    margin-left: 6px;
  }
}
.service-dialog {
  ::v-deep {
    .el-dialog {
      border-radius: 8px;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
    }
    .el-dialog__headerbtn {
      display: none;
    }
    .el-dialog__header {
      padding: 16px 24px 22px 24px;
    }
    .el-dialog__body {
      padding: 0 24px;
      max-height: 490px;
      overflow-y: auto;
    }
    .el-dialog__footer {
      padding: 24px;
    }
    .el-button {
      padding: 10px 19px;
    }
  }
}
.dialog-service {
  margin-bottom: 28px;
  &:last-child {
    margin-bottom: 0;
  }
}
.dialog-service_icon {
  width: 18px;
  height: 18px;
}
.dialog-service_name {
  font-size: 15px;
  font-family: PingFangSC, PingFangSC-Medium;
  color: #333333;
  line-height: 24px;
  margin-left: 7px;
}
.dialog-service_description {
  color: #999999;
  line-height: 24px;
  margin-top: 4px;
}
</style>
